<style lang="scss" scoped>
.stamp {
    position: absolute;
    width: 338px;
    height: 262px;
    right: -29px;
    top: 204px;
    transform: rotate(20deg);
    z-index: 10;
}

.intro-page {
    position: relative;
    width: 100vw;
    height: 100vh;
    background: white;

    display: flex;
    justify-content: space-between;

    overflow: hidden;

    .divider {
        position: absolute;
        left: 50%;

        height: 200%;
        width: 3.5rem;

        border-left: 1.5rem solid $background-light-blue;
        border-right: 1.5rem solid $background-light-blue;

        transform: translateX(-50%) translateY(-25%) rotate(10deg);
    }

    .left,
    .right {
        position: relative;

        height: 200%;
        width: 50%;

        display: flex;
        justify-content: center;
        align-items: center;

        > * {
            position: relative;
            max-width: 50%;
        }

        .subtitle {
            position: absolute;
            top: 100%;
        }

        > a {
            position: absolute;
            min-width: 150%;
            max-width: 150%;
            height: 100%;
            z-index: 10;

            &:hover {
                background: rgba($color: #000000, $alpha: 0.1);
            }
        }
    }

    .left {
        transform: translateY(-25%) translateX(-5%) rotate(10deg);

        > div {
            transform: rotate(-10deg) translateX(5%) translateY(-25%);
        }

        > a {
            right: 0;
        }
    }

    .right {
        transform: translateY(-25%) translateX(5%) rotate(10deg);

        > div {
            transform: rotate(-10deg) translateX(-20%) translateY(-25%);
        }

        > a {
            left: 0;
        }
    }

    .button {
        position: absolute;
        margin-left: 5%;
        top: 60%;
    }
}

a.home:hover {
    color: black;
}
</style>

<template>
    <div class="intro-page">
        <div class="left">
            <div>
                <a class="home" :href="route('main')">
                    <span class="job-fox-logo"><svg-vue icon="djf_logo"></svg-vue></span>
                    <span class="title font-titillium-italic-bold-49">{{ $trans("navigation.nav_title") }}</span>
                </a>
            </div>
            <a class="home" :href="route('main')"></a>
            <div class="button">
                <breeze-button>{{ $trans("navigation.nav_continue").toUpperCase() }}</breeze-button>
            </div>
        </div>
        <div class="divider"></div>
        <div class="right">
            <div>
                <a class="home" :href="route('search.index')">
                    <div class="job-fox-logo"><svg-vue icon="djf_logo"></svg-vue></div>
                    <div class="title font-titillium-italic-bold-49">{{ $trans("navigation.nav_title") }}</div>
                    <div class="subtitle font-titillium-italic-bold-49">{{ $trans("navigation.nav_search_title") }}</div>
                </a>
            </div>
            <a class="home" :href="route('search.index')"></a>
            <div class="button">
                <breeze-button>{{ $trans("navigation.nav_continue").toUpperCase() }}</breeze-button>
            </div>
        </div>
    </div>
</template>

<script>
import BreezeButton from "@/Components/Button.vue";

export default {
    components: { BreezeButton },
};
</script>
